const controllers = require('../Http/Controllers')


module.exports = {
  home: {
    component: controllers.HomepageController,
    path: '/',
    name: 'home',
  },
  notFound: {
    component: controllers.NotFoundController,
    path: '/404',
    name: 'notFound',
  },
  looks: {
    component: controllers.LooksController,
    path: '/looks',
    name: 'looks',
  },
  page: {
    component: controllers.PageController,
    path: '/:slug',
    name: 'page',
  },
}
